import Checkbox from './Checkbox'

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Form/components/Checkbox/index.js